import React from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  IconButton,
  Tooltip,
} from "@chakra-ui/react";
import {
  TriangleUpIcon,
  TriangleDownIcon,
  SearchIcon,
} from "@chakra-ui/icons";
import {
  FaRegFileAlt,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";
import { IoIosSend } from "react-icons/io";
import Num from '../common/Num';



function SortableTh({ show, label, sortKey, sortConfig, onSort, numeric }) {
  if (!show) return null;
  return (
    <Th
      cursor="pointer"
      onClick={() => onSort(sortKey)}
      isNumeric={numeric}
    >
      {label}{" "}
      {sortConfig.key === sortKey &&
        (sortConfig.direction === "asc" ? (
          <TriangleUpIcon ml={1} />
        ) : (
          <TriangleDownIcon ml={1} />
        ))}
    </Th>
  );
}

export default function QuotesTable({
  quotes,
  columns,
  sortConfig,
  onSort,
  onDetail,
}) {
  const getStatusIcon = (id) => {
    switch (id) {
      case 1:
        return <FaRegFileAlt title="Bozza" />;
      case 2:
        return <IoIosSend title="Inviato" />;
      case 3:
        return <FaCheckCircle title="Accettato" />;
      case 4:
        return <FaTimesCircle title="Rifiutato" />;
      default:
        return "—";
    }
  };

  return (
    <Table variant="striped" size="sm">
      <Thead>
        <Tr>
          <SortableTh
            show={columns.id}
            label="NUMERO"
            sortKey="id"
            sortConfig={sortConfig}
            onSort={onSort}
          />
          <SortableTh
            show={columns.date}
            label="Data"
            sortKey="date"
            sortConfig={sortConfig}
            onSort={onSort}
          />
          <SortableTh
            show={columns.total_amount}
            label="Totale"
            sortKey="total_amount"
            sortConfig={sortConfig}
            onSort={onSort}
            numeric
          />
          <SortableTh
            show={columns.discount_extra}
            label="Sconto Extra"
            sortKey="discount_extra"
            sortConfig={sortConfig}
            onSort={onSort}
            numeric
          />
          {columns.note && <Th>Note</Th>}
          {columns.user && <Th>Utente</Th>}
          {columns.quote_status && <Th>Stato</Th>}
          <Th>Azioni</Th>
        </Tr>
      </Thead>

      <Tbody>
        {quotes.map((q) => (
          <Tr key={q.id}>
            {columns.id && <Td>{q.id}</Td>}
            {columns.date && <Td>{q.date}</Td>}
            {columns.total_amount && (
              <Td isNumeric><Num value={q.total_amount} fmt="€" /></Td>)}
            {columns.discount_extra && (
              <Td isNumeric><Num value={q.discount_extra} fmt="%" /></Td>)}
            {columns.note && <Td>{q.note || "—"}</Td>}
            {columns.user && <Td>{q.user?.name || "—"}</Td>}
            {columns.quote_status && (
              <Td>{getStatusIcon(q.quote_status_id)}</Td>
            )}
            <Td>
              <Tooltip label="Dettagli">
                <IconButton
                  icon={<SearchIcon />}
                  size="sm"
                  variant="ghost"
                  onClick={() => onDetail(q)}
                  aria-label="Dettagli"
                />
              </Tooltip>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
}
